(function(root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports && typeof document === 'undefined') {
    module.exports = factory(null, null);
    return;
  }

  if (!root.xpertzaCartCro) {
    root.xpertzaCartCro = factory(root, root.document);
  }

  root.xpertzaCartCro.init();
}(typeof window !== 'undefined' ? window : this, function(window, document) {
  'use strict';

  var lifecycleBound = false;
  var drawerClassObserver = null;
  var pendingNote = null;
  var pendingNoteDisclosure = null;

  function normalizeCents(value) {
    var cents = parseInt(value, 10);
    return cents > 0 ? cents : 0;
  }

  function calculateProgress(totalCents, thresholdCents) {
    var total = normalizeCents(totalCents);
    var threshold = normalizeCents(thresholdCents) || 5000;
    var remaining = Math.max(threshold - total, 0);
    var percent = Math.min(Math.floor((total * 100) / threshold), 100);

    return {
      percent: Math.max(percent, 0),
      remaining: remaining,
      threshold: threshold,
      total: total,
      unlocked: remaining === 0
    };
  }

  function formatMoney(cents) {
    if (!window.theme || !window.theme.Currency || typeof window.theme.Currency.formatMoney !== 'function') {
      return '';
    }

    return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
  }

  function createChangeEvent(eventDocument) {
    var event = eventDocument.createEvent('HTMLEvents');
    event.initEvent('change', true, false);
    return event;
  }

  function findAncestorByClass(element, className) {
    var current = element;

    while (current && current !== document) {
      if (current.classList && current.classList.contains(className)) {
        return current;
      }
      current = current.parentNode;
    }

    return null;
  }

  function findRemoveButton(element) {
    var current = element;

    while (current && current !== document) {
      if (current.getAttribute && current.hasAttribute('data-xpertza-cart-remove')) {
        return current;
      }
      current = current.parentNode;
    }

    return null;
  }

  function removeCartItem(button) {
    var item = findAncestorByClass(button, 'xpertza-cart-item');
    var quantityInput = item ? item.querySelector('input[name="updates[]"]') : null;

    if (!button || button.disabled || !quantityInput) {
      return false;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    quantityInput.value = 0;
    quantityInput.dispatchEvent(createChangeEvent(quantityInput.ownerDocument || document));
    return true;
  }

  function isCartNote(element) {
    return Boolean(element) &&
      element.getAttribute &&
      element.getAttribute('name') === 'note' &&
      Boolean(findAncestorByClass(element, 'xpertza-cart-note'));
  }

  function calculateScrollAdjustment(viewportTop, viewportBottom, contentTop, contentBottom, margin) {
    var safeMargin = Math.max(parseInt(margin, 10) || 0, 0);

    if (contentBottom > viewportBottom - safeMargin) {
      return contentBottom - viewportBottom + safeMargin;
    }

    if (contentTop < viewportTop + safeMargin) {
      return contentTop - viewportTop - safeMargin;
    }

    return 0;
  }

  function revealCartNote(note, moveFocus) {
    var scrollable = findAncestorByClass(note, 'drawer__scrollable');
    var textarea = note ? note.querySelector('textarea[name="note"]') : null;

    if (!note || !note.open || !scrollable || !textarea) {
      return false;
    }

    var scrollableRect = scrollable.getBoundingClientRect();
    var noteRect = note.getBoundingClientRect();
    var adjustment = calculateScrollAdjustment(
      scrollableRect.top,
      scrollableRect.bottom,
      noteRect.top,
      noteRect.bottom,
      12
    );

    if (adjustment) {
      scrollable.scrollTop += adjustment;
    }

    if (moveFocus && typeof textarea.focus === 'function') {
      textarea.focus();
    }

    return true;
  }

  function scheduleCartNoteReveal(note, moveFocus) {
    var requestFrame = window.requestAnimationFrame || function(callback) {
      return window.setTimeout(callback, 16);
    };

    requestFrame(function() {
      revealCartNote(note, moveFocus);
    });
  }

  function revealExistingCartNote() {
    var container = document.getElementById('CartContainer');
    var note = container ? container.querySelector('.xpertza-cart-note[open]') : null;

    if (note) {
      scheduleCartNoteReveal(note, false);
    }
  }

  function restorePendingNote(cart) {
    var container = document.getElementById('CartContainer');
    var textarea = container ? container.querySelector('textarea[name="note"]') : null;
    var disclosure = textarea ? findAncestorByClass(textarea, 'xpertza-cart-note') : null;

    if (pendingNote === null || !textarea) {
      return;
    }

    if (cart && String(cart.note || '') === pendingNote) {
      pendingNote = null;
      return;
    }

    textarea.value = pendingNote;
    if (disclosure) {
      disclosure.open = pendingNote.replace(/\s/g, '').length > 0;
    }
  }

  function ensureEmptyDrawerComponent(cart) {
    if (!cart || cart.item_count !== 0) {
      return;
    }

    var container = document.getElementById('CartContainer');
    var template = document.querySelector('[data-xpertza-empty-cart-cro-template]');
    var target = container ? container.querySelector('.drawer__scrollable') : null;

    if (!container || !template || !target || container.querySelector('[data-xpertza-cart-cro]')) {
      return;
    }

    if (template.content) {
      target.appendChild(template.content.cloneNode(true));
    }
  }

  function updateRoot(rootElement, cart) {
    if (!rootElement || !cart) {
      return;
    }

    var state = calculateProgress(cart.total_price, rootElement.getAttribute('data-xpertza-threshold-cents'));
    var messageElement = rootElement.querySelector('[data-xpertza-progress-message]');
    var track = rootElement.querySelector('[data-xpertza-progress-track]');
    var fill = rootElement.querySelector('[data-xpertza-progress-fill]');
    var unlockedText = rootElement.getAttribute('data-xpertza-unlocked-text');
    var formattedRemaining = formatMoney(state.remaining);
    var message = state.unlocked ? unlockedText : 'Add ' + formattedRemaining + ' more for free shipping!';

    if (messageElement) {
      messageElement.textContent = message;
    }

    if (track) {
      track.setAttribute('aria-valuenow', String(state.percent));
      track.setAttribute('aria-label', message);
    }

    if (fill) {
      fill.style.width = state.percent + '%';
    }
  }

  function updateAll(cart) {
    ensureEmptyDrawerComponent(cart);
    restorePendingNote(cart);
    var roots = document.querySelectorAll('[data-xpertza-cart-cro]');

    for (var index = 0; index < roots.length; index += 1) {
      updateRoot(roots[index], cart);
    }

    revealExistingCartNote();
  }

  function syncCartDrawerState() {
    var drawerOpen = document.body.classList.contains('js-drawer-open');
    document.body.classList.toggle('xpertza-cart-drawer-open', drawerOpen);
    return drawerOpen;
  }

  function init() {
    if (!document) {
      return;
    }

    if (lifecycleBound) {
      return;
    }
    lifecycleBound = true;

    function bindEvents() {
      syncCartDrawerState();

      if (window.MutationObserver && !drawerClassObserver) {
        drawerClassObserver = new window.MutationObserver(syncCartDrawerState);
        drawerClassObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (window.jQuery) {
        window.jQuery('body')
          .off('updateCart.ajaxcart.xpertzaCartCro')
          .on('updateCart.ajaxcart.xpertzaCartCro', function(event, cart) {
            updateAll(cart);
          })
          .off('drawerOpen.xpertzaCartCro')
          .on('drawerOpen.xpertzaCartCro', function() {
            revealExistingCartNote();
          });
      }

      document.addEventListener('cart:updated', function(event) {
        if (event.detail && event.detail.cart) {
          updateAll(event.detail.cart);
        }
      });

      document.addEventListener('input', function(event) {
        if (isCartNote(event.target)) {
          pendingNote = event.target.value;
        }
      });

      document.addEventListener('click', function(event) {
        var summary = findAncestorByClass(event.target, 'xpertza-cart-note__summary');
        var button = findRemoveButton(event.target);

        if (summary) {
          var note = findAncestorByClass(summary, 'xpertza-cart-note');
          pendingNoteDisclosure = note && !note.open ? note : null;
        }

        if (!button) {
          return;
        }

        event.preventDefault();
        removeCartItem(button);
      });

      document.addEventListener('toggle', function(event) {
        var note = event.target;

        if (!note.classList || !note.classList.contains('xpertza-cart-note')) {
          return;
        }

        if (note.open) {
          scheduleCartNoteReveal(note, note === pendingNoteDisclosure);
        }

        pendingNoteDisclosure = null;
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindEvents);
    } else {
      bindEvents();
    }
  }

  return {
    calculateScrollAdjustment: calculateScrollAdjustment,
    calculateProgress: calculateProgress,
    init: init,
    normalizeCents: normalizeCents,
    removeCartItem: removeCartItem,
    syncCartDrawerState: syncCartDrawerState
  };
}));
